import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getAccessToken } from '@repo/token-storage';
import { directLogout } from './authn-client';
const AuthnContext = /*#__PURE__*/ createContext(undefined);
export const AuthnProvider = (param)=>{
    let { children } = param;
    const [token, setToken] = useState(getAccessToken());
    const logout = useCallback(async ()=>{
        await directLogout();
        setToken(null);
    }, []);
    const refreshToken = useCallback(()=>{
        setToken(getAccessToken());
    }, []);
    const value = useMemo(()=>({
            token,
            logout,
            refreshToken
        }), [
        token,
        logout,
        refreshToken
    ]);
    return /*#__PURE__*/ _jsx(AuthnContext.Provider, {
        value: value,
        children: children
    });
};
export const useAuthnProvider = ()=>{
    const context = useContext(AuthnContext);
    if (!context) {
        throw new Error('useAuthProvider must be used within an AuthProvider');
    }
    return context;
};
